const store = {
    state: {
        selectedOrder:null,
        createdOrders:[],
    },
    getters: {
        orderStatusOptions(state) {
            return [
                { value: "ORDERED", name: "Ordered" },
                { value: "ACCEPTED", name: "Accepted" },
                { value: "ACKNOWLEDGED", name: "Acknowledged" },
                { value: "COLLECTED", name: "Collected" },
                { value: "WAREHOUSE", name: "Warehouse" },
                { value: "PROCESSING", name: "Processing" },
                { value: "FAILED", name: "Failed" },
                { value: "FAILED COLLECTION", name: "Failed Collection" },
                { value: "SIGNED", name: "Signed" },
                { value: "PHOTO", name: "Photo" },
                { value: "RETURNED", name: "Returned" },
                { value: "DELIVERED", name: "Delivered" },
                { value: "DROPOFF", name: "Dropoff" },
                { value: "REDELIVERED", name: "Redelivery" },
                { value: "CANCELLED", name: "Cancelled" }
            ];
        },
        getSelectedOrder(state) {
            return state.selectedOrder;
        },
        getCreatedOrders(state){
            return state.createdOrders;
        }
    },
    mutations: {
        UPDATE_SELECTED_ORDER(state, val) {
            state.selectedOrder = val;
        },
        UPDATE_CREATED_ORDERS(state, val) {
            state.createdOrders = val;
        }
    },
    actions: {
        updateSelectedOrder({ commit }, val) {
            commit("UPDATE_SELECTED_ORDER", val);
        },
        updateCreatedOrders({ commit }, val) {
            commit("UPDATE_CREATED_ORDERS", val);
        }
    }
};

export default store;
